import styled from "styled-components";

export const Title = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 38px;
  color: #2A2637;
  width: 300px;
  margin-bottom: 24px;
  @media(max-width: 970px) {
    margin-top: 36px
  }
  @media(max-width: 768px) {
    font-size: 20px;
    width: 200px;
    line-height: 28px;
  }
`

export const List = styled.ul`
  list-style-type: disc; 
  padding-left: 20px;
`

export const Container = styled.div`
  display: block;
  @media(max-width: 480px) {
    width: 300px;
  }
`

export const Text = styled.li`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #4E4963;
  margin-bottom: 10px;
  width: 444px;
  &:last-child {
    margin-bottom: 12px;
  }
  @media(max-width: 768px) {
    font-size: 14px;
    width: 300px;
  }
`

export const Badges = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 0;
  @media (min-width: 414px) {
    justify-content: flex-start;
  }
`

export const Badge = styled.div`
  img {
    width: 152px;
    height: auto;
  }
  
  @media (min-width: 320px) {
    img {
      width: 100%;
    }
  }
  
  @media (min-width: 414px) {
    margin-right: 24px;

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 162px;
    }
  }
  @media(max-width: 480px) {
     margin-right: 24px;
     &:last-child {
      margin-right: 0;
    }
  }
`


